import { render, staticRenderFns } from "./TransferReport.vue?vue&type=template&id=353aaad2"
import script from "./TransferReport.vue?vue&type=script&lang=js"
export * from "./TransferReport.vue?vue&type=script&lang=js"
import style0 from "./TransferReport.vue?vue&type=style&index=0&id=353aaad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports